export const OCEAN_PATCH_URL =
  "https://static.prod-images.emergentagent.com/jobs/beaf1473-0440-47c8-8ba8-3b3802060e3c/images/675d633465046ba65b1829c4d087302eaacd841a1e26a806a6753ac9af58d296.jpeg";

export const OCEAN_POSTER_URL =
  "https://static.prod-images.emergentagent.com/jobs/beaf1473-0440-47c8-8ba8-3b3802060e3c/images/537196754beb4264d645f4ff51d381eecd0709cb622ebfe7536eb892e3387d1c.jpeg";

export const OIMG = {
  hero: "https://images.unsplash.com/photo-1682687981630-cefe9cd73072?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  diver: "https://images.unsplash.com/photo-1682687982502-1529b3b33f85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  reefFish: "https://images.unsplash.com/photo-1586508577428-120d6b072945?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  turtle: "https://images.unsplash.com/photo-1591025207163-942350e47db2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  turtle2: "https://images.unsplash.com/photo-1496196614460-48988a57fccf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  coastKonkan: "https://images.unsplash.com/photo-1766415599729-144fffce2cfb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  coastRocky: "https://images.unsplash.com/photo-1780505990476-6fd82de12d8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  islandAndaman: "https://images.unsplash.com/photo-1780553012388-a6c98f17e294?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  beach: "https://images.unsplash.com/photo-1767027663311-7d6572de0f90?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  vessel: "https://images.unsplash.com/photo-1578331831830-53b0e47d19f4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  vessel2: "https://images.unsplash.com/photo-1629719995289-d7a19e818f25?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  satEarth: "https://images.unsplash.com/photo-1614730321146-b6fa6a46bcb4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  satellite: "https://images.unsplash.com/photo-1460186136353-977e9d6085a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const OCEAN_NAV_LINKS = [
  { label: "Why Ocean", href: "#why-ocean" },
  { label: "Regions", href: "#regions" },
  { label: "Programme", href: "#programme" },
  { label: "Data", href: "#technology" },
  { label: "Roadmap", href: "#roadmap" },
  { label: "Safety", href: "#safety" },
  { label: "Partners", href: "#partners" },
  { label: "Join", href: "#join" },
];

export const OCEAN_MARQUEE = [
  "SAME OCEAN. BIGGER QUESTIONS.",
  "DIVE INDIA. MAP TOMORROW.",
  "FROM REEFS TO RESILIENCE.",
  "EXPLORE. OBSERVE. MAP. UNDERSTAND. PROTECT.",
];

export const WHY_OCEAN_CARDS = [
  {
    title: "Marine Biodiversity",
    desc: "Document reef fish, marine life and habitat associations through permitted, well-recorded underwater observations.",
    img: OIMG.reefFish,
  },
  {
    title: "Coral Reefs & Habitats",
    desc: "Describe reef structure, substrate and visible habitat features — at a scale satellites cannot resolve underwater.",
    img: OIMG.turtle2,
  },
  {
    title: "Coastal Resilience",
    desc: "Investigate shoreline change, sediment plumes and coastal environmental indicators relevant to communities.",
    img: OIMG.coastKonkan,
  },
  {
    title: "Marine Debris & Pollution",
    desc: "Record visible debris and coastal pollution during authorised dives, with georeferenced field notes.",
    img: OIMG.beach,
  },
  {
    title: "Ocean & Maritime Intelligence",
    desc: "Integrate ocean-colour and sea-surface-temperature products with contextual observations where suitable.",
    img: OIMG.satEarth,
  },
];

export const OCEAN_WORKFLOW = [
  "Satellite observations",
  "Regional environmental context",
  "Dive-site planning",
  "Authorised underwater observations",
  "Geospatial analysis",
  "Documented findings",
];

export const OCEAN_REGIONS = [
  {
    id: "west",
    code: "REGION A",
    name: "Western Coast & Arabian Sea",
    img: OIMG.coastKonkan,
    blurb:
      "From the Gulf of Kutch to Lakshadweep's atolls — rocky reefs, lagoons and nearshore habitats along India's western seaboard.",
    habitats: ["Coral atolls & lagoons", "Rocky nearshore reefs", "Intertidal & coastal habitats", "Marine protected areas"],
    themes: ["Reef habitat documentation", "Coastal change observation", "Biodiversity notes"],
    satellite: "Sentinel-2 optical, Sentinel-3 ocean-colour, MODIS/VIIRS regional products",
    access: "Mix of public diving destinations and protected areas requiring specific authorisation.",
    status: "PROPOSED",
    sites: ["Gulf of Kutch (Gujarat)", "Malvan & Tarkarli (Maharashtra)", "Goa coastal reefs", "Karnataka nearshore", "Kerala coastal habitats", "Lakshadweep atolls"],
  },
  {
    id: "east",
    code: "REGION B",
    name: "Eastern Coast & Bay of Bengal",
    img: OIMG.coastRocky,
    blurb:
      "The Gulf of Mannar, Palk Bay and the northern Bay of Bengal — reefs, estuaries and mangrove-adjacent coastal systems.",
    habitats: ["Gulf of Mannar reefs", "Palk Bay habitats", "Estuarine & mangrove-adjacent systems", "Nearshore ecosystems"],
    themes: ["Coastal resilience", "Pollution-context observation", "Habitat description"],
    satellite: "Sentinel-3 SST & ocean-colour, Landsat coastal context, MODIS/VIIRS time-series",
    access: "Several sensitive and protected areas; permissions and environmental restrictions apply.",
    status: "UNDER ASSESSMENT",
    sites: ["Gulf of Mannar (Tamil Nadu)", "Palk Bay", "Visakhapatnam (Andhra Pradesh)", "Odisha coast", "Sundarbans-adjacent (West Bengal)"],
  },
  {
    id: "andaman",
    code: "REGION C",
    name: "Andaman & Nicobar Islands",
    img: OIMG.islandAndaman,
    blurb:
      "Coral reefs and island ecosystems around Swaraj Dweep (Havelock) and Shaheed Dweep (Neil) — environmentally sensitive, access-restricted.",
    habitats: ["Coral reefs", "Island ecosystems", "Underwater habitat features", "Protected marine areas"],
    themes: ["Reef observation", "Marine biodiversity notes", "Remote-sensing applications"],
    satellite: "Sentinel-2 shallow-water context, Landsat historical change, oceanographic datasets",
    access: "Strict protected-area, tribal-reserve and permit requirements. No unrestricted access implied.",
    status: "UNDER ASSESSMENT",
    sites: ["Swaraj Dweep (Havelock)", "Shaheed Dweep (Neil)", "Other legally accessible sites"],
  },
  {
    id: "offshore",
    code: "REGION D",
    name: "Offshore & Open-Ocean Environments",
    img: OIMG.vessel2,
    blurb:
      "Research-vessel-based observations in offshore waters — pursued only when qualification, vessel, weather, safety and authorisations permit.",
    habitats: ["Offshore reef environments", "Pelagic observation zones", "Underwater terrain features"],
    themes: ["Satellite-derived ocean conditions", "Marine debris observation", "Vessel-based data collection"],
    satellite: "Sentinel-3 ocean products, MODIS/VIIRS, oceanographic & meteorological data",
    access: "Advanced activity — not a routine beginner environment. Separate feasibility and safety planning required.",
    status: "PROPOSED",
    sites: ["Arabian Sea offshore zones", "Bay of Bengal offshore zones"],
  },
];

// Leaflet markers: [lat, lng] with region + status
export const MAP_MARKERS = [
  { region: "west", name: "Gulf of Kutch", coords: [22.55, 69.6], status: "PROPOSED" },
  { region: "west", name: "Malvan / Tarkarli", coords: [16.05, 73.47], status: "PROPOSED" },
  { region: "west", name: "Goa reefs", coords: [15.3, 73.9], status: "PROPOSED" },
  { region: "west", name: "Karnataka nearshore", coords: [14.3, 74.3], status: "PROPOSED" },
  { region: "west", name: "Kerala coast", coords: [9.95, 76.2], status: "PROPOSED" },
  { region: "west", name: "Lakshadweep atolls", coords: [10.57, 72.64], status: "UNDER ASSESSMENT" },
  { region: "east", name: "Gulf of Mannar", coords: [9.1, 79.1], status: "UNDER ASSESSMENT" },
  { region: "east", name: "Palk Bay", coords: [9.6, 79.3], status: "UNDER ASSESSMENT" },
  { region: "east", name: "Visakhapatnam", coords: [17.7, 83.3], status: "PROPOSED" },
  { region: "east", name: "Odisha coast", coords: [19.8, 85.8], status: "PROPOSED" },
  { region: "east", name: "Sundarbans-adjacent", coords: [21.75, 88.9], status: "UNDER ASSESSMENT" },
  { region: "andaman", name: "Swaraj Dweep (Havelock)", coords: [12.02, 92.98], status: "UNDER ASSESSMENT" },
  { region: "andaman", name: "Shaheed Dweep (Neil)", coords: [11.83, 93.05], status: "UNDER ASSESSMENT" },
  { region: "offshore", name: "Arabian Sea offshore", coords: [13.5, 71.5], status: "PROPOSED" },
  { region: "offshore", name: "Bay of Bengal offshore", coords: [14.5, 84.5], status: "PROPOSED" },
];

export const REGION_COLORS = {
  west: "#42D6D0",
  east: "#0F7194",
  andaman: "#E5B65B",
  offshore: "#F26B5B",
};

export const OCEAN_WORKSTREAMS = [
  {
    code: "WS-A",
    title: "Underwater Habitat Documentation",
    items: ["Underwater photography and video", "Georeferenced field records", "Habitat and substrate descriptions", "Standardised observation protocols"],
  },
  {
    code: "WS-B",
    title: "Marine Biodiversity Observations",
    items: ["Opportunistic species observations", "Expert-supported identification", "Habitat associations", "Documented observation limitations"],
    note: "No population estimates or biodiversity surveys are claimed without a suitable sampling design and scientific oversight.",
  },
  {
    code: "WS-C",
    title: "Coastal & Marine Environmental Intelligence",
    items: ["Suitable ocean-colour products", "Sea-surface-temperature datasets", "Coastal change and sediment indicators", "Contextual oceanographic datasets"],
  },
  {
    code: "WS-D",
    title: "Marine Debris & Pollution Observations",
    items: ["Documentation of visible debris during permitted dives", "Shoreline and coastal observations", "Georeferenced records", "Potential mapping and reporting workflows"],
    note: "Visible observations are distinct from chemical analysis or verified pollution-source attribution.",
  },
  {
    code: "WS-E",
    title: "Satellite-to-Dive Data Integration",
    items: ["Prepare satellite-derived environmental layers", "Document dive observations with timestamps and coordinates", "Assess spatial and temporal alignment", "Develop exploratory visualisations and document uncertainty"],
  },
];

export const OCEAN_TECH_CARDS = [
  { code: "S2", title: "Sentinel-2", desc: "Optical imagery for coastal land-cover and shallow-water habitat context. Optical observations are limited by depth and water clarity." },
  { code: "S3", title: "Sentinel-3", desc: "Regional ocean and environmental products, including ocean-colour and sea-surface-temperature where suitable." },
  { code: "LS", title: "Landsat", desc: "Historical coastal and land-surface context where appropriate." },
  { code: "MV", title: "MODIS & VIIRS", desc: "Regional environmental observations and time-series products." },
  { code: "OCN", title: "Oceanographic & Met Data", desc: "Ocean, wave, current, weather and water-condition information from appropriate sources." },
  { code: "CAM", title: "Underwater Cameras", desc: "Visual documentation, subject to dive safety, visibility and image quality." },
  { code: "GPS", title: "GPS & Dive Logs", desc: "Location, time, depth and conditions. Ordinary GPS does not provide positioning once a diver is submerged." },
  { code: "GIS", title: "GIS & Python", desc: "Geospatial processing, spatial analysis, data quality control and reproducibility." },
  { code: "CLD", title: "Cloud & Geospatial AI", desc: "Scalable data processing, exploratory analysis and demonstrator hosting." },
];

export const OCEAN_PHASES = [
  {
    num: "01",
    title: "Mission Definition",
    status: "IN DEVELOPMENT",
    items: ["Define research questions", "Select initial coastal regions", "Establish the proposed scope", "Define success criteria"],
  },
  {
    num: "02",
    title: "Research & Diving Partnerships",
    status: "IN DEVELOPMENT",
    items: ["Identify marine scientists and institutions", "Engage qualified dive operators", "Identify suitable dive locations", "Determine permissions and restrictions"],
  },
  {
    num: "03",
    title: "Technology Preparation",
    status: "PLANNED",
    items: ["Select satellite datasets", "Prepare observation protocols", "Develop field-log templates", "Test geospatial workflows and assess equipment"],
  },
  {
    num: "04",
    title: "Initial Coastal Expeditions",
    status: "PLANNED",
    items: ["Start with accessible locations", "Dive within each participant's qualifications", "Record permitted underwater observations", "Maintain field records and data provenance"],
  },
  {
    num: "05",
    title: "Expanded Regional Expeditions",
    status: "UNDER ASSESSMENT",
    items: ["Extend to other coastal regions and islands", "Expand only as funding and logistics permit", "Assess research-vessel and offshore feasibility separately"],
  },
  {
    num: "06",
    title: "Analysis & Reporting",
    status: "PLANNED",
    items: ["Process field records", "Compare suitable observations with satellite products", "Assess uncertainty and limitations", "Produce technical case studies and visual reports"],
  },
];

export const SAFETY_RULES = [
  "Recognised scuba training and certification",
  "Individual experience and medical fitness",
  "Appropriate buddy procedures",
  "Qualified dive professionals on site",
  "Weather, currents, visibility and sea conditions",
  "Equipment checks and emergency plans",
  "Suitable surface support and emergency assistance",
  "Applicable local regulations and site restrictions",
];

export const CONSERVATION_RULES = [
  "Do not touch, collect or damage coral",
  "Maintain neutral buoyancy and distance from marine life",
  "Do not feed, chase or harass animals",
  "Avoid anchoring on sensitive habitats",
  "Do not disturb protected species or habitats",
  "Follow protected-area and marine regulations",
  "Use appropriate procedures for any scientific sampling",
  "Respect local communities and coastal livelihoods",
  "Share sensitive species or habitat locations responsibly",
];

export const OCEAN_PARTNER_CATEGORIES = [
  "Marine science & oceanography institutions",
  "Universities & research organisations",
  "Scuba operators & expedition leaders",
  "Marine conservation organisations",
  "Satellite-data providers",
  "Geospatial & cloud technology companies",
  "Ocean technology & blue economy",
  "Corporate sponsors",
  "Scientific communication & documentary",
];

export const OCEAN_PROSPECTIVE_ORGS = [
  "National Institute of Ocean Technology",
  "National Centre for Coastal Research",
  "National Centre for Polar and Ocean Research (marine science)",
  "Indian universities with marine-science or remote-sensing expertise",
  "Established Earth-observation & satellite-data providers",
  "Qualified Indian scuba operators & expedition leaders",
];

export const OCEAN_EXPERTISE = [
  "Certified scuba diver",
  "Marine biologist",
  "Oceanographer",
  "Remote-sensing specialist",
  "GIS engineer",
  "Environmental data scientist",
  "Underwater photographer / videographer",
  "Field documentation specialist",
  "Expedition coordinator",
  "Research / conservation partner",
  "Other",
];

export const OCEAN_PREFERRED_REGIONS = [
  "Western Coast & Arabian Sea",
  "Eastern Coast & Bay of Bengal",
  "Andaman & Nicobar Islands",
  "Offshore & open ocean",
  "No preference",
];

export const OCEAN_COMPLIANCE = [
  "No dive permits have been issued and no vessel or dive site has been booked.",
  "No scientific institution or dive operator has confirmed a partnership.",
  "No sponsor has committed funding and no field observations have been completed.",
  "All expedition locations, dates and routes are proposed or under assessment, not confirmed.",
  "Prospective organisations named are for investigation only — no endorsement is implied.",
  "This is not a substitute for formal scientific training or a recognised diving qualification.",
];
